import PrivacyPolicy from 'pages/PrivacyPolicy'

import { Screen } from 'constants/tracking/screens'
import useTranslate from 'hooks/useTranslate'

import PageHead from '../../components/Head/PageHead'
import fullPageLayout from '../../layouts/FullPage'
import { getLayoutServerSideProps } from '../../layouts/FullPage/server-props'
import { emptyPropsCallback } from '../../libs/server-utils/ssr'

const PrivacyPolicyPage = () => {
  const translate = useTranslate('privacy_policy')

  return (
    <>
      <PageHead title={translate('page_title')} />
      <PrivacyPolicy />
    </>
  )
}

export default fullPageLayout(PrivacyPolicyPage, { isWhiteBackground: false })

export const getServerSideProps = getLayoutServerSideProps(emptyPropsCallback, {
  screen: Screen.PrivacyPolicy,
})
